import axios, { AxiosInstance } from 'axios';
import { getCacheKey } from '@m2h/common/utils/hasher';
import { createPrefetchApi, getUrlCache, setUrlForceRefresh } from './apiPrefetcher';
import { IRequestParams } from './type';
import {
  errorCode, addCommonHeaders, addPrefix, loginCheck, returnAllData,
} from './interceptors';
import {
  addGlobalexp,
} from './addGlobalexp';

/*
  以下请求携带验签信息
 */
axios.defaults.withCredentials = true;

// 设置所有请求默认超时
axios.defaults.timeout = 25000; // 25秒

let APICONFIG = {
  autoApiPrefix: true,
  autoErrorCode: false,
};

export const requestConfig = (options?) => {
  APICONFIG = { ...APICONFIG, ...options };
  return APICONFIG;
};

//@ts-ignore
const axiosInstance: AxiosInstance = axios.create({ withCredentials: true });
axiosInstance.interceptors.request.use(addCommonHeaders);
axiosInstance.interceptors.request.use(addGlobalexp);
axiosInstance.interceptors.request.use(addPrefix);
axiosInstance.interceptors.response.use(loginCheck);

/*
【pureRequest】无默认请求头，无i18n，无登录校验，返回全部数据
  用于跨域请求等
 */
const pureRequestInstance = axios.create({ withCredentials: true });
pureRequestInstance.interceptors.request.use(addPrefix);
pureRequestInstance.interceptors.response.use(returnAllData);

export async function pureRequest(reqParams: IRequestParams) {
  try {
    const { url } = reqParams || {};
    // 有的url没带'/'开头
    let _url = `${url.startsWith('/') || url.startsWith('http') ? url : `/${url}`}`;

    // 有的url没带api开头，自动添加/api，单个请求可通过其config覆盖是否自动添加
    if (APICONFIG.autoApiPrefix) {
      !_url.startsWith('/api') && !_url.startsWith('http') && (_url = `/api${_url}`);
    }

    // console.log(reqParams, 'reqParams');

    const urlFinal = _url;

    if (APICONFIG.autoErrorCode) {
      pureRequestInstance.interceptors.response.use(errorCode);
    }

    const data: any = await pureRequestInstance({ ...reqParams, url: urlFinal });
    return data;
  } catch (error) {
    return {
      error
    };
  }
}

export default async (reqParams: IRequestParams) => {
  let urlFinal = '';
  let finalReqParams = { ...reqParams };
  try {
    const { url } = reqParams || {};
    // 有的url没带'/'开头
    let _url = `${url.startsWith('/') || url.startsWith('http') ? url : `/${url}`}`;

    // 有的url没带api开头，自动添加/api，单个请求可通过其config覆盖是否自动添加
    if (APICONFIG.autoApiPrefix) {
      !_url.startsWith('/api') && !_url.startsWith('http') && (_url = `/api${_url}`);
    }

    // console.log(reqParams, 'reqParams');

    urlFinal = _url;

    if (APICONFIG.autoErrorCode) {
      axiosInstance.interceptors.response.use(errorCode);
    }
    finalReqParams.url = urlFinal;
  } catch (error) {
    return {
      error
    };
  }

  const finalReq = async () => {
    try {
      const data: any = await axiosInstance(finalReqParams);
      return data;
    } catch (error) {
      return {
        error
      };
    }
  };

  const urlCache = getUrlCache(urlFinal);

  if (urlCache) {
    const cacheKey = getCacheKey(finalReqParams);
    console.log(urlFinal, cacheKey, 'createPrefetchApi', urlCache.defaultRefresh);
    try {
      const preFetchAxiosInstance = createPrefetchApi(cacheKey, axiosInstance, urlCache.cacheTime);
      const data1 = await preFetchAxiosInstance(finalReqParams, urlCache.forceRefresh);
      // 请求正常返回时，统一设置默认刷新状态，默认不刷新
      setUrlForceRefresh(urlFinal, urlCache.defaultRefresh);
      return data1;
    } catch (error) {
      // 异常时强制请求
      setUrlForceRefresh(urlFinal, true);
      return finalReq();
    }
  } else {
    return finalReq();
  }
};
